import Immutable from "immutable";
import { Client } from "resourceModels";

export default class MessengerPlatformRecord extends Immutable.Record({
  name: "messenger",
  fullName: "Messenger",
  accessToken: "",
  enabled: true,

  isVisibleToClient(client: Client): boolean {
    return (
      client.hasFullSitePrivileges &&
      !client.features.get("zendeskClient")
    );
  }
}) {}
